import { Link } from 'react-router-dom'
import { StatusBadge } from '@/components/ui'
import type { VagaResumo } from '../types'
import { formatLocal, formatSalario, prioridadeLabel, statusLabel, statusTone } from '../utils'

export function VagaCard({ vaga }: { vaga: VagaResumo }) {
  return (
    <article className={`card hi-vaga-card is-prio-${vaga.prioridade || 'media'}`}>
      <header className="hi-vaga-card-head">
        <div>
          <p className="hi-vaga-card-empresa">
            {vaga.empresa_grupo_nome || 'Grupo HI'}
            {vaga.departamento_nome ? ` · ${vaga.departamento_nome}` : ''}
          </p>
          <h4>{vaga.titulo}</h4>
        </div>
        <StatusBadge tone={statusTone(vaga.status)}>{statusLabel(vaga.status)}</StatusBadge>
      </header>
      <ul className="hi-meta">
        <li>{formatLocal(vaga.cidade, vaga.uf)}</li>
        <li>{(vaga.modalidade || '-').replace('_', ' ')}</li>
        <li>{(vaga.tipo_contrato || '-').toUpperCase()}</li>
        <li>{formatSalario(vaga.salario_min, vaga.salario_max, vaga.salario_oculto)}</li>
      </ul>
      <footer className="hi-vaga-card-foot">
        <span>
          <strong>{vaga.total_candidatos ?? 0}</strong> candidatos · prioridade{' '}
          {prioridadeLabel(vaga.prioridade)}
        </span>
        <div className="hi-actions">
          <Link className="btn btn-secondary btn-xs" to={`/app/recrutamento/${vaga.id}`}>
            Detalhe
          </Link>
          <Link className="btn btn-secondary btn-xs" to={`/app/recrutamento/${vaga.id}?tab=pipeline`}>
            Pipeline
          </Link>
        </div>
      </footer>
    </article>
  )
}
